import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';
import { UiKitAccordion } from './UiKitAccordion';

export const uiKitAccordionComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'uiKitAccordion',
  component: UiKitAccordion,
  tagName: 'uikitaccordion',
  stylable: false,
  droppable: false,
  defaultAttributes: {
    items: JSON.stringify([{ title: 'Заголовок', content: 'Содержимое' }]),
  },
  traits: [
    {
      name: 'items',
      type: 'text',
    },
  ],
  block: {
    label: 'Accordion',
    category: 'UI Components',
    content: '<UIKitAccordion />',
  },
};
